module.exports = __webpack_public_path__ + "4c70cc7da81a21cf5e54991fc41a138a.svg";